<template>
  <v-dialog
    persistent
    v-model="dialog"
    width="600"
    :fullscreen="$vuetify.breakpoint.mdAndDown"
    :hide-overlay="$vuetify.breakpoint.mdAndDown"
  >
    <template v-slot:activator="{ on: { click } }">
      <v-tooltip
        v-model="showTooltip"
        top
        color="transparent"
        content-class="help-bubble"
        nudge-left="100%"
        :disabled="dialog"
        @click.native="showTooltip = false"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            :active="dialog"
            :fab="!$vuetify.breakpoint.mdAndUp"
            :small="!$vuetify.breakpoint.mdAndUp"
            class="ml-2"
            color="primary"
            tile
            @click="click"
            v-on="on"
          >
            <v-icon x-large>mdi-video-account</v-icon>
            <span class="ml-1" v-show="$vuetify.breakpoint.mdAndUp">{{
              $t("participant.live.videoRooms.videoRooms")
            }}</span>
          </v-btn>
        </template>
        <v-card width="350px">
          <v-card-title>{{ $t("participant.live.videoRooms.help.title") }}</v-card-title>
          <v-card-text class="text-justify">{{ $t("participant.live.videoRooms.help.text") }}</v-card-text>
        </v-card>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title class="py-0">
        <h4>{{ $t("participant.live.videoRooms.videoRooms") }}</h4>
        <v-spacer />
        <v-text-field
          :label="$t('participant.live.videoRooms.find')"
          class="expand-on-focus"
          prepend-inner-icon="mdi-magnify"
          v-model="findQuery"
        >
          <v-icon @click="findQuery = ''" slot="append" v-if="findQuery">mdi-close</v-icon>
        </v-text-field>
        <v-menu v-model="filterOptions" :close-on-content-click="false" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon>
              <v-icon>mdi-filter</v-icon>
            </v-btn>
          </template>
          <v-card flat>
            <v-card-text>
              <v-switch
                :label="$t('participant.live.videoRooms.displayFullRooms')"
                class="mr-5"
                style="width: 100%"
                v-model="displayFullRooms"
                dense
              ></v-switch>
              <v-switch
                :label="$t('participant.live.videoRooms.displayEmptyRooms')"
                class="mr-5"
                style="width: 100%"
                v-model="displayEmptyRooms"
                dense
              ></v-switch>
            </v-card-text>
          </v-card>
        </v-menu>
      </v-card-title>
      <v-card-text class="scrollable pb-0">
        <v-slide-y-transition group tag="v-list" class="video-room-list py-0">
          <v-list-item :key="sessionRoom.id" v-for="sessionRoom in this.roomsToShow" class="px-0">
            <v-list-item-content>
              <v-row no-gutters>
                <v-col class="subtitle-1" cols="9">
                  {{ sessionRoom.name }}
                </v-col>
                <v-col cols="3" class="text-center">
                  <span class="subtitle-1"
                    >{{ !sessionRoom.participants ? 0 : sessionRoom.participants.length }}/7</span
                  >
                  <v-icon class="ml-1">mdi-account-multiple</v-icon>
                </v-col>
              </v-row>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn
                :disabled="sessionRoom.participants && sessionRoom.participants.length >= 7"
                @click="joinSessionRoom(sessionRoom)"
                color="primary"
                :icon="!$vuetify.breakpoint.smAndUp"
              >
                <v-icon large v-show="!$vuetify.breakpoint.smAndUp">mdi-location-enter</v-icon>
                <span v-show="$vuetify.breakpoint.smAndUp">{{ $t("participant.live.videoRooms.join") }}</span>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-list-item v-if="inEditMode" class="px-0" key="new">
            <v-list-item-content>
              <v-form @submit.prevent="saveNewRoomAndJoin">
                <v-text-field
                  :label="$t('participant.live.videoRooms.roomName')"
                  :rules="[$v.required()]"
                  autocomplete="off"
                  name="newEventName"
                  required
                  v-model="newRoomName"
                  ref="newRoomField"
                >
                  <template v-slot:append-outer>
                    <v-btn :disabled="!newRoomName" color="primary" elevation="0" fab tile type="submit" x-small>
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                    <v-btn @click="exitEditMode()" class="ml-1" elevation="0" fab tile x-small>
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-form>
            </v-list-item-content>
          </v-list-item>
        </v-slide-y-transition>
      </v-card-text>
      <v-card-actions class="px-5 pb-5 pt-3">
        <v-btn @click="enterEditMode()" v-if="!inEditMode" color="secondary" outlined>
          <v-icon class="mr-2">mdi-plus</v-icon>
          {{ $t("participant.live.videoRooms.createNew") }}
        </v-btn>
        <v-spacer />
        <v-btn @click="dialog = false" text color="secondary">{{ $t("participant.live.videoRooms.close") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from "axios";

export default {
  name: "ParticipantVideoRooms",
  data() {
    return {
      findQuery: null,
      displayFullRooms: false,
      displayEmptyRooms: true,
      dialog: false,
      videoRoomDialog: false,
      sessionRooms: [],
      inEditMode: false,
      showTooltip: false,
      newRoomName: null,
      filterOptions: false,
      refreshInterval: null,
    };
  },
  methods: {
    async loadSessionRooms() {
      this.sessionRooms = await axios.get(`/event/activities/session/${this.$store.state.sessionId}/sessionRooms`);
    },
    enterEditMode() {
      this.inEditMode = true;
      setTimeout(() => this.$refs.newRoomField.focus(), 10);
    },
    exitEditMode() {
      this.inEditMode = false;
    },
    async saveNewRoomAndJoin() {
      this.inEditMode = false;

      let addedRoom = await axios.post(`/event/activities/session/${this.$store.state.sessionId}/sessionRoom`, {
        roomName: this.newRoomName,
      });

      this.sessionRooms.push(addedRoom);

      this.newRoomName = "";

      await this.joinSessionRoom(addedRoom);
    },
    async joinSessionRoom(sessionRoom) {
      this.dialog = false;
      let videoRoomTokenAndSession = await axios.post(
        `/event/activities/sessionRooms/${sessionRoom.id}/join/${this.$store.state.participantId}`
      );

      this.$store.commit("VIDEO_ROOM_OPENTOK_TOKEN", videoRoomTokenAndSession.videoRoomOpenTokToken);
      this.$store.commit("VIDEO_ROOM_OPENTOK_SESSION", videoRoomTokenAndSession.videoRoomOpenTokSessionId);
      this.$store.commit("VIDEO_ROOM", sessionRoom);
    },
  },
  watch: {
    dialog(open) {
      if (open) {
        this.loadSessionRooms();
        this.refreshInterval = setInterval(() => this.loadSessionRooms(), 5000);
      } else {
        clearInterval(this.refreshInterval);
      }
    },
  },
  computed: {
    roomsToShow() {
      let sessionRoomsToReturn = this.sessionRooms;
      if (!this.displayFullRooms) {
        sessionRoomsToReturn = sessionRoomsToReturn.filter(
          (sessionRoom) => !sessionRoom.participants || sessionRoom.participants.length < 7
        );
      }

      if (!this.displayEmptyRooms) {
        sessionRoomsToReturn = sessionRoomsToReturn.filter(
          (sessionRoom) => sessionRoom.participants && sessionRoom.participants.length > 0
        );
      }

      if (this.findQuery)
        sessionRoomsToReturn = sessionRoomsToReturn.filter(
          (sessionRoom) => sessionRoom.name.toLowerCase().indexOf(this.findQuery.toLowerCase()) !== -1
        );

      return sessionRoomsToReturn;
    },
  },
};
</script>
<style scoped>
.expand-on-focus {
  max-width: 150px;
  transition: max-width 300ms ease-in-out;
}

@media (min-width: 600px) {
  .expand-on-focus.v-input--is-focused {
    max-width: 100%;
  }
}

.v-list.video-room-list {
  min-height: 250px;
  background-image: url("/assets/video_rooms.svg");
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 250px auto;
}

.scrollable {
  max-height: calc(100vh - 138px);
  overflow: auto;
}

@media (min-width: 960px) {
  .scrollable {
    max-height: calc(90vh - 138px);
  }
}
</style>
